import styled from 'styled-components';

export const ContainerMounting = styled.div``;

export const MountingExplanation = styled.p`
    color: ${({ theme }) => theme.colors.text};

    &:last-child {
        margin-bottom: 16px;
        color: ${({ theme }) => theme.colors.textSecondary};
    }
`;

export const Info = styled.p`
    padding: 4px 8px;
    color: ${({ theme }) => theme.colors.textSecondary};
`;
